import { useEffect } from 'react';

import { AnimatePresence, motion } from 'framer-motion';
import { useHistory, useParams } from 'react-router';
import { css } from 'styled-components';

import Spinner from 'src/app/components/Elements/Spinner';
import { DoormanConfirmationStep } from 'src/app/components/Pages/Order/FailedOrderReschedule/DoormanFailedOrderConfirmationStep';
import { useGetOrder } from 'src/app/hooks/data/order';
import { ORDER_STATUSES } from 'src/consts';

import { InitialRescheduleFailedOrderStep } from './InitialRescheduleFailedOrderStep';
import type { RescheduleOrderPathParams } from './types';
import { RescheduleOrderStepName } from './types';
import { VerifyFailedOrderAddressStep } from './VerifyFailedOrderAddressStep';

export const RescheduleOrder = () => {
  const { goBack } = useHistory();
  const { orderId, stepName: currentStepName } = useParams<RescheduleOrderPathParams>();

  const { data: order, isLoading: isOrderLoading } = useGetOrder(orderId);

  const isOrderPostponed = order?.status === ORDER_STATUSES.postponed;

  useEffect(() => {
    if (!isOrderLoading && !isOrderPostponed) goBack();
  }, [goBack, isOrderLoading, isOrderPostponed]);

  if (isOrderLoading) return <Spinner centered />;

  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div
        css={css`
          height: 100%;
        `}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3, ease: 'easeIn' }}
        key={`reschedule-order-${currentStepName}`}
      >
        {currentStepName === RescheduleOrderStepName.Initial && <InitialRescheduleFailedOrderStep />}
        {currentStepName === RescheduleOrderStepName.VerifyAddress && <VerifyFailedOrderAddressStep />}
        {currentStepName === RescheduleOrderStepName.DoormanConfirmation && <DoormanConfirmationStep />}
      </motion.div>
    </AnimatePresence>
  );
};
